<section class="tc-version-diff" aria-labelledby="tc-version-diff-heading">
  <to-section-title
    headingId="tc-version-diff-heading"
    [title]="'testCases.form.sections.versionDiff.title' | translate"
    [subtitle]="'testCases.form.sections.versionDiff.subtitle' | translate"
  />

  @if (loading()) {
    <div class="tc-version-diff__loading">
      <mat-spinner diameter="28" />
    </div>
  } @else if (loadError()) {
    <p class="tc-version-diff__hint tc-version-diff__hint--error" role="alert">
      {{ 'testCases.form.versionDiff.loadError' | translate }}
    </p>
  } @else if (!previous()) {
    <p class="tc-version-diff__hint">{{ 'testCases.form.versionDiff.noPrevious' | translate }}</p>
  } @else {
    <div class="tc-version-diff__grid">
      <div class="tc-version-diff__col">
        <span class="tc-version-diff__col-label tc-version-diff__col-label--current">
          <span class="tc-version-diff__dot" aria-hidden="true"></span>
          {{ 'testCases.form.versionDiff.current' | translate }}
          @if (current()?.version !== null) {
            <span>· {{ current()?.version }}</span>
          }
        </span>

        <div class="tc-version-diff__field">
          <span class="tc-version-diff__field-label">{{ 'testCases.form.versionDiff.version' | translate }}</span>
          <span class="tc-version-diff__value">{{ current()?.version }}</span>
        </div>

        <div class="tc-version-diff__field">
          <span class="tc-version-diff__field-label">{{ 'testCases.form.versionDiff.titleField' | translate }}</span>
          <span class="tc-version-diff__value">{{ current()?.title }}</span>
        </div>

        <div class="tc-version-diff__field">
          <span class="tc-version-diff__field-label">{{ 'testCases.form.versionDiff.description' | translate }}</span>
          <span class="tc-version-diff__value tc-version-diff__value--multiline">
            {{ current()?.description || '—' }}
          </span>
        </div>
      </div>

      <div class="tc-version-diff__col">
        <span class="tc-version-diff__col-label tc-version-diff__col-label--previous">
          <span class="tc-version-diff__dot" aria-hidden="true"></span>
          {{ 'testCases.form.versionDiff.previous' | translate }}
          @if (previous()?.version !== null) {
            <span>· {{ previous()?.version }}</span>
          }
        </span>

        <div class="tc-version-diff__field">
          <span class="tc-version-diff__field-label">{{ 'testCases.form.versionDiff.version' | translate }}</span>
          <span class="tc-version-diff__value">{{ previous()?.version }}</span>
        </div>

        <div class="tc-version-diff__field">
          <span class="tc-version-diff__field-label">{{ 'testCases.form.versionDiff.titleField' | translate }}</span>
          <span class="tc-version-diff__value">{{ previous()?.title }}</span>
        </div>

        <div class="tc-version-diff__field">
          <span class="tc-version-diff__field-label">{{ 'testCases.form.versionDiff.description' | translate }}</span>
          <span class="tc-version-diff__value tc-version-diff__value--multiline">
            {{ previous()?.description || '—' }}
          </span>
        </div>
      </div>
    </div>

    @if (changeCount() > 0) {
      <p class="tc-version-diff__summary" role="status">
        <mat-icon class="tc-version-diff__summary-icon" aria-hidden="true">check_circle</mat-icon>
        <span>
          <strong>
            {{
              (changeCount() === 1
                ? 'testCases.form.versionDiff.changesCountOne'
                : 'testCases.form.versionDiff.changesCountOther'
              ) | translate: { count: changeCount() }
            }}
          </strong>
          {{ 'testCases.form.versionDiff.changesSince' | translate: { version: previous()?.version } }} —
          @for (field of changedFields(); track field; let last = $last) {
            {{ 'testCases.form.versionDiff.fields.' + field | translate }}{{ last ? '' : ', ' }}
          }
        </span>
      </p>
    }
  }
</section>
